import UbsApiV2 from "./UbsApiV2";

export const getLiveDashboard = async (params = {}) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const response = await UbsApiV2.get(`/ssc/bookings/live_dashboard`, {
    headers: headers,
    params: params,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });

  return response;
};
